import React from 'react'
import { useUserContext } from '../../context/userContext';
import AsyncSelect from 'react-select/async';
import { debounce } from "lodash";
import { getSiteItemApi } from '../../utils/ApiEndpointFunctions';

function InventoryItemModal(props) {
  const { modalId, formik, disable } = props
  const {userDetails,langPreference} = useUserContext()
  const hasWriteAccess = userDetails?.roleId?.permission?.includes("inventoryWrite")
  const isNew = !formik?.values?._id

  const selectZeroOnFocus = (event) => {
    if (event.currentTarget.value === "0") {
      event.currentTarget.select();
    }
  }

  const filteritems = async (inputValue, cb) => {
    try {
      const res = await getSiteItemApi(inputValue)
      if (res.status === 200) {
        let fetchedItem = res.data?.data?.data?.map(ele => ({ label: ele?.details?.name, value: {...ele?.details, _id: ele?.details?.uniqueItemId } }))
        cb(fetchedItem);
      }
    } catch (error) {
      console.log(error)
    }
  };

  const itemsOnChange = debounce(filteritems, 1000);

  const itemsOptions = (inputValue, callback) => {
    itemsOnChange(inputValue, callback);
  }

  const handleItemSelect = (e) => {
    formik.setFieldValue("name", e.value);
    formik.setFieldValue("hsnCode", e.value?.hsnCode);
    formik.setFieldValue("localName", e.value?.localName);
    formik.setFieldValue("description", e.value?.description);
    formik.setFieldValue("unitType", e.value?.unitType);
    formik.setFieldValue("tax", e.value?.tax);
    formik.setFieldValue("uniqueItemId", e.value?._id);
  }

  return (
    <div className="modal fade" id={modalId} tabIndex="-1" aria-labelledby={`${modalId}Label`} aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered modal-lg inventory-item-modal">
        <div className="modal-content">
          <form onSubmit={formik?.handleSubmit}>
            <div className="modal-header inventory-item-modal__header">
              <div>
                <span>{isNew ? (langPreference?.add || "Add") : (langPreference?.edit || "Edit")}</span>
                <h5 className="modal-title" id={`${modalId}Label`}>{langPreference?.inventory_item || "Inventory Item"}</h5>
              </div>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>

            <div className="modal-body inventory-item-modal__body">
              <section className="inventory-item-modal__section">
                <h6>{langPreference?.item_details || "Item Details"}</h6>
                <div className="inventory-item-modal__grid">
                  {isNew ? <div className="inventory-item-modal__field inventory-item-modal__field--wide">
                    <label htmlFor="name" className="form-label">{langPreference?.name || "Name"}</label>
                    <AsyncSelect
                      className="inventory-item-modal__select"
                      classNamePrefix="inventory-item-select"
                      placeholder={langPreference?.select || "Select"}
                      cacheOptions
                      loadOptions={itemsOptions}
                      defaultOptions
                      name="name"
                      value={formik?.values?.name ? { label: formik?.values?.name?.name, value: formik?.values?.name } : null}
                      onChange={handleItemSelect}
                    />
                    {formik?.touched?.name && formik?.errors?.name ? <div className="req-error">{formik?.errors?.name}</div> : null}
                  </div> : <div className="inventory-item-modal__field inventory-item-modal__field--wide">
                    <label htmlFor="name" className="form-label">{langPreference?.name || "Name"}</label>
                    <input type="text" className="form-control" id="name" disabled name="name" value={formik?.values?.name || ""} />
                  </div>}

                  <div className="inventory-item-modal__field">
                    <label htmlFor="localName" className="form-label">{langPreference?.local_name || "Local Name"}</label>
                    <input type="text" className="form-control" id="localName" disabled name="localName" value={formik?.values?.localName || ""} />
                  </div>
                  <div className="inventory-item-modal__field">
                    <label htmlFor="hsnCode" className="form-label">{langPreference?.hsn_code || "HSN Code"}</label>
                    <input type="text" className="form-control" id="hsnCode" disabled name="hsnCode" value={formik?.values?.hsnCode || ""} />
                  </div>
                  <div className="inventory-item-modal__field inventory-item-modal__field--wide">
                    <label htmlFor="description" className="form-label">{langPreference?.description || "Description"}</label>
                    <input type="text" className="form-control" id="description" disabled name="description" value={formik?.values?.description || ""} />
                  </div>
                  <div className="inventory-item-modal__field">
                    <label htmlFor="unitType" className="form-label">{langPreference?.unit || "Unit"}</label>
                    <input type="text" className="form-control" id="unitType" disabled name="unitType" value={formik?.values?.unitType || ""} />
                  </div>
                  {!isNew && <div className="inventory-item-modal__field">
                    <label htmlFor="availableQty" className="form-label">{langPreference?.available_quantity || "Available Quantity"}</label>
                    <input type="text" className="form-control" id="availableQty" disabled name="availableQty" value={formik?.values?.availableQty ?? 0} />
                  </div>}
                </div>
              </section>

              {hasWriteAccess && <section className="inventory-item-modal__section inventory-item-modal__section--controls">
                <h6>{langPreference?.inventory_controls || "Inventory Controls"}</h6>
                <div className="inventory-item-modal__grid">
                  <div className="inventory-item-modal__field">
                    <label htmlFor="itemType" className="form-label">{langPreference?.asset_type || "Asset Type"}</label>
                    <select className="form-select" id="itemType" name="itemType" value={formik?.values?.itemType?.toLowerCase()} onChange={formik?.handleChange} onBlur={formik?.handleBlur}>
                      <option value="fixed">Fixed</option>
                      <option value="consumable">Consumable</option>
                    </select>
                    {formik?.touched?.itemType && formik?.errors?.itemType ? <div className="req-error">{formik?.errors?.itemType}</div> : null}
                  </div>
                  <div className="inventory-item-modal__field">
                    <label htmlFor="minQty" className="form-label">{langPreference?.minimum_quantity || "Minimum Quantity"}</label>
                    <input type="text" className="form-control" id="minQty" name="minQty" value={formik?.values?.minQty} onChange={(event) => {
                      if (/^\d*$/.test(event.target.value)) formik?.handleChange(event)
                    }} onFocus={selectZeroOnFocus} onBlur={formik?.handleBlur} />
                    <small>{langPreference?.notification_quantity_alert || `Notification is sent below ${formik?.values?.minQty || 0}`}</small>
                    {formik?.touched?.minQty && formik?.errors?.minQty ? <div className="req-error">{formik?.errors?.minQty}</div> : null}
                  </div>
                  <div className="inventory-item-modal__field">
                    <label htmlFor="addedQty" className="form-label">{langPreference?.add_quantity || "Add Quantity"}</label>
                    <input type="text" className="form-control" id="addedQty" name="addedQty" value={formik?.values?.addedQty} onChange={(event) => {
                      if (/^\d*$/.test(event.target.value)) formik?.handleChange(event)
                    }} onFocus={selectZeroOnFocus} onBlur={formik?.handleBlur} />
                    {formik?.touched?.addedQty && formik?.errors?.addedQty ? <div className="req-error">{formik?.errors?.addedQty}</div> : null}
                  </div>
                  <div className="inventory-item-modal__track">
                    <div>
                      <label className="form-check-label" htmlFor="inventoryTrackSwitch">{langPreference?.track || "Track Inventory"}</label>
                      <small>{langPreference?.track_inventory_help || "Include this item in stock movement tracking"}</small>
                    </div>
                    <div className="form-check form-switch mb-0">
                      <input className="form-check-input" name="isTrack" type="checkbox" role="switch" id="inventoryTrackSwitch" checked={formik?.values?.isTrack} onChange={(event) => formik?.setFieldValue("isTrack", event.target.checked)} onBlur={formik?.handleBlur} />
                    </div>
                    {formik?.touched?.isTrack && formik?.errors?.isTrack ? <div className="req-error">{formik?.errors?.isTrack}</div> : null}
                  </div>
                </div>
              </section>}
            </div>

            <div className="modal-footer inventory-item-modal__footer">
              <button type="button" className="btn btn-outline-secondary" data-bs-dismiss="modal">{langPreference?.cancel || "Cancel"}</button>
              {hasWriteAccess && <button disabled={disable} type="submit" className="btn btn-primary">
                {disable ? (langPreference?.saving || "Saving...") : (langPreference?.save || "Save")}
              </button>}
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default InventoryItemModal
